import Crud from '@/views/CheckRequest/Crud'
import Add from '@/views/CheckRequest/Add'

import Approve from '@/views/CheckRequest/Approve'

const routes = {
  path: '/checkRequest',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/checkRequests',
      name: 'list-check-request',
      component: Crud,
    },
    {
      path: '/checkRequests/edit/:id?',
      name: 'Solicitação de marcação',
      component: Add,
    },
    {
      path: '/checkRequests/add',
      name: 'Solicitação de marcação',
      component: Add,
    },
    {
      path: '/checkRequests/approve',
      name: 'Aprovar solicitações de marcação',
      component: Approve,
    },
  ],
}

export default routes
